import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CorporationSkillFrameworkSelectionRequest } from '../../entities/corporation-skill-frameworks.model';
import { SkillFramework } from '../../entities/skills-framework.model';
import { DashboardApiService } from '../db-api.service';

const DEPT_CORP_OPT_IN_URL = '/v1/issuer/corporation_skill_framework_selections';

@Injectable({
  providedIn: 'root',
})
export class IssuerCorporationFrameworkOptInApiService extends DashboardApiService {
  protected override _getHeaders(method: string, endpoint: string): { [header: string]: string } {
    const headers = super._getHeaders(method, endpoint);
    return {
      ...headers,
      'accredible-department-id': this.embedding.departmentId.toString(),
    };
  }

  createOptIn(request: CorporationSkillFrameworkSelectionRequest): Observable<SkillFramework> {
    return this._post(DEPT_CORP_OPT_IN_URL, {
      corporation_skill_framework_selection: request,
    }).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }
}
